import { render, staticRenderFns } from "./ConfirmarPago.vue?vue&type=template&id=f53a198c&scoped=true&lang=pug"
import script from "./ConfirmarPago.vue?vue&type=script&lang=js"
export * from "./ConfirmarPago.vue?vue&type=script&lang=js"
import style0 from "./ConfirmarPago.vue?vue&type=style&index=0&id=f53a198c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53a198c",
  null
  
)

export default component.exports